
<div *ngIf="showScrollbar" class="d-flex justify-content-start free-courses mx-1 w-100 mb-2 pb-2">
    @for (video of videos; track video) {
        <div [ngClass]="{
            'free-courses-item': maxItemsPerRow === 0,
            'free-courses-item-max-1': maxItemsPerRow === 1,
            'free-courses-item-max-2': maxItemsPerRow === 2,
            'free-courses-item-max-3': maxItemsPerRow === 3,
            'free-courses-item-max-4': maxItemsPerRow === 4,
            'free-courses-item-max-5': maxItemsPerRow === 5}"
            class="card card-skinny w-100 col-8 col-md-2 pt-0 px-0 pb-2 mr-3 ml-0 border-top-left-radius-modal border-top-right-radius-modal">
            <div *ngIf="$index === 7" class="card-header w-100 border-top-left-radius-modal border-top-right-radius-modal"
                [ngStyle]="{'background-image': 'linear-gradient(to right, rgba(0,0,0,0.1), rgba(255,255,255,255)), url('+ video.thumbnailUrl + ')'}">
                <ng-container *ngIf="!isLearnToFlyCoursePaid">
                    <div class="lock-new" *ngIf="!colorSchemeService.isDarkMode()"></div>
                    <div class="lock-new-white" *ngIf="colorSchemeService.isDarkMode()"></div>
                </ng-container>
            </div>
            <div *ngIf="$index !== 7" class="card-header w-100 border-top-left-radius-modal border-top-right-radius-modal"
                [ngStyle]="{'background-image': 'url('+ video.thumbnailUrl + ')'}" (click)="goToVideo(video)">
                <ng-container *ngIf="!isLearnToFlyCoursePaid">
                    <div class="lock-new" *ngIf="!colorSchemeService.isDarkMode() && $index > course.lastDemoCourse"></div>
                    <div class="lock-new-white" *ngIf="colorSchemeService.isDarkMode() && $index > course.lastDemoCourse"></div>
                </ng-container>
            </div>
            <div class="w-100">
                <div class="d-flex justify-content-start mt-3 px-2 card-title">
                    <div class="text-size-18">
                        {{video.sectionId}}.
                    </div>
                    <div class="text-size-18 ml-1 faded-text">
                        {{video.description}}
                    </div>
                </div>
                <div class="align-items-end">
                    <hr class="color-secondary-dark w-100 my-2">
                    <div class="d-flex justify-content-between w-100 px-2">
                        <div class="d-flex align-items-center">
                            <span>{{video.runtime}}</span>
                        </div>
                        <button class="btn btn-round"
                            [ngClass]="{'btn-primary':$index < 6 || isLearnToFlyCoursePaid, 'color-black btn-white border-black p-1':$index >= 6 && !isLearnToFlyCoursePaid}" [disabled]="$index >= 6 && !isLearnToFlyCoursePaid"
                            (click)="goToVideo(video)">
                            Start Lesson
                            <app-icon class="pl-1" *ngIf="$index >= 6 && !isLearnToFlyCoursePaid && !colorSchemeService.isDarkMode()" glyph name="lock-black"></app-icon>
                            <app-icon class="pl-1" *ngIf="$index >= 6 && !isLearnToFlyCoursePaid && colorSchemeService.isDarkMode()" glyph name="lock-white-small"></app-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="$index === 7" class="btn btn-primary btn-round view-all-btn" (click)="viewAllVideos()">View All
            </div>
        </div>
    }
</div>
<div *ngIf="!showScrollbar" class="row d-flex justify-content-start free-courses mx-1 w-100 mb-2 pb-2">
    @for (video of videos; track video;) {
        <div [ngClass]="{
            'fit-content-item': fitContent,
            'col': !fitContent,
            'free-courses-item': maxItemsPerRow === 0,
            'free-courses-item-max-1': maxItemsPerRow === 1,
            'free-courses-item-max-2': maxItemsPerRow === 2,
            'free-courses-item-max-3': maxItemsPerRow === 3,
            'free-courses-item-max-4': maxItemsPerRow === 4,
            'free-courses-item-max-5': maxItemsPerRow === 5}" class="px-2 mt-4">
            <div
                class="card card-skinny w-100 p-0 pb-2 border-top-left-radius-modal border-top-right-radius-modal border-bottom-right-radius-modal border-bottom-left-radius-modal">
                <div *ngIf="$index === 7" class="card-header w-100 border-top-left-radius-modal border-top-right-radius-modal"
                    [ngStyle]="{'background-image': 'linear-gradient(to right, rgba(0,0,0,0.1), rgba(255,255,255,255)), url('+ video.thumbnailUrl + ')'}">
                    <ng-container *ngIf="!isLearnToFlyCoursePaid">
                        <div class="lock-new" *ngIf="!colorSchemeService.isDarkMode()"></div>
                        <div class="lock-new-white" *ngIf="colorSchemeService.isDarkMode()"></div>
                    </ng-container>
                </div>
                <div *ngIf="$index !== 7" class="card-header w-100 border-top-left-radius-modal border-top-right-radius-modal"
                    [ngStyle]="{'background-image': 'url('+ video.thumbnailUrl + ')'}" (click)="goToVideo(video)">
                    <ng-container *ngIf="!isLearnToFlyCoursePaid">
                        <div class="lock-new" *ngIf="$index === 6 && !colorSchemeService.isDarkMode()"></div>
                        <div class="lock-new-white" *ngIf="$index === 6 && colorSchemeService.isDarkMode()"></div>
                    </ng-container>
                </div>

                <div class="w-100">
                    <div class="d-flex justify-content-start mt-3 px-2 card-title">
                        <div class="text-size-16">
                            {{video.sectionId}}.
                        </div>
                        <div class="text-size-16 ml-1" [class.faded-text]="$last">
                            {{video.description}}
                        </div>
                    </div>
                    <div class="align-items-end">
                        <hr class="color-secondary-dark w-100 my-2">
                        <div class="d-flex justify-content-between w-100 px-2">
                            <div class="d-flex align-items-center text-size-12 text-gray">
                                <span>{{video.runtime}}</span>
                            </div>
                            <button class="btn btn-round text-size-14"
                                [ngClass]="{'btn-primary':$index < 7 || isLearnToFlyCoursePaid, 'color-black btn-white border-black p-1':$index >= 6 && !isLearnToFlyCoursePaid}" [disabled]="$index >= 6 && !isLearnToFlyCoursePaid"
                                (click)="goToVideo(video)">
                                Start Lesson
                                <app-icon class="pl-1" *ngIf="$index >= 6 && !isLearnToFlyCoursePaid && !colorSchemeService.isDarkMode()" glyph name="lock-black"></app-icon>
                                <app-icon class="pl-1" *ngIf="$index >= 6 && !isLearnToFlyCoursePaid && colorSchemeService.isDarkMode()" glyph name="lock-white-small"></app-icon>
                            </button>
                        </div>
                    </div>

                </div>
                <div *ngIf="$index === 7" class="btn btn-primary btn-round view-all-btn" (click)="viewAllVideos()">View All
                </div>
            </div>
        </div>
    }
</div>
